/*
  Lazy loader voor Swiper, gedeeld door ss-hero-32, ss-testimonials-38 en
  ss-product-vidoes. Stond in alle drie byte-identiek inline (~2,3KB per view).

  Swiper is self-hosted op de Shopify-CDN (was jsdelivr) op een gepinde versie:
  scheelt third-party DNS/TLS en supply-chain-risico. De CSS wordt pas
  geinjecteerd zodra een sectie load() aanroept, niet bij het parsen.

  URL's komen van de script-tag zelf:
    <script src="...resty-swiper-loader.js"
            data-swiper-css="..." data-swiper-js="..." defer></script>
*/
(() => {
  if (window.RestySwiperLoader) return;

  const config = document.currentScript.dataset;

  window.RestySwiperLoader = {
    version: '11.2.10',
    cssUrl: config.swiperCss,
    jsUrl: config.swiperJs,
    promise: null,
    stylesPromise: null,
    ensureStyles() {
      if (this.stylesPromise) return this.stylesPromise;

      // De URL is de identiteit; er is één gepinde versie, dus href volstaat.
      let stylesheet = document.querySelector(`link[href="${this.cssUrl}"]`);
      if (!stylesheet) {
        stylesheet = document.createElement('link');
        stylesheet.rel = 'stylesheet';
        stylesheet.href = this.cssUrl;
      }

      this.stylesPromise = new Promise((resolve) => {
        if (stylesheet.sheet) {
          resolve();
          return;
        }
        // Ook bij een fout doorlopen: een slider die nooit initialiseert is
        // erger dan eentje zonder Swiper-CSS.
        stylesheet.addEventListener('load', resolve, { once: true });
        stylesheet.addEventListener('error', resolve, { once: true });
      });

      if (!stylesheet.isConnected) document.head.appendChild(stylesheet);
      return this.stylesPromise;
    },
    load() {
      // Wachten tot de CSS écht toegepast is, niet alleen aangevraagd:
      // secties halen hun pre-init-fallback weg zodra dit resolvet, en zonder
      // .swiper-wrapper{display:flex} stapelen de slides tot een kolom van
      // duizenden pixels (testimonials-38: 427px -> 18.000px).
      return Promise.all([this.ensureStyles(), this.loadScript()]).then(() => window.Swiper);
    },
    loadScript() {
      if (window.Swiper) return Promise.resolve(window.Swiper);
      if (this.promise) return this.promise;

      this.promise = new Promise((resolve, reject) => {
        let script = document.querySelector(`script[src="${this.jsUrl}"]`);
        const handleLoad = () => resolve(window.Swiper);
        const handleError = () => {
          script.remove();
          this.promise = null;
          reject(new Error(`Unable to load Swiper ${this.version}`));
        };

        if (!script) {
          script = document.createElement('script');
          script.src = this.jsUrl;
          script.async = true;
        }

        script.addEventListener('load', handleLoad, { once: true });
        script.addEventListener('error', handleError, { once: true });
        if (!script.isConnected) document.head.appendChild(script);
      });

      return this.promise;
    },
  };
})();
